export class ToolEditModel {
    constructor() {
        this.name = "";
        this.latestVersion = null;
        this.discription = null;
        this.url = null;
    }
}
export default class ToolEdit extends ToolEditModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
